// ink-component
import React, { ReactNode } from 'react';
import { StyledComponentPropsWithAs } from 'babel-plugin-styled-components';
import Heading from '../../Heading/Heading';
import useSunsetWarning from '../../../../hooks/useSunsetWarning';
import getGlobalProps from '../../../../helpers/constants/global-props';

export interface Heading2Props extends StyledComponentPropsWithAs {
  /** A **textual** HTML tag to be used when rendering the text node, like 'p', 'h6' or 'small' for example. */
  as?: string;
  /** Horizontal alignment of the text inside `children` */
  align?: 'inherit' | 'left' | 'center' | 'right';
  /** Removes the white space below the heading */
  trim?: boolean;
  /** Content */
  children?: ReactNode;
  /** @ignore */
  'aria-level'?: string;
}

const globalProps = getGlobalProps({ sunset: true });

/**
 * @purpose Most prominent heading after Heading1
 * @group Typography
 * @position 2
 * @status sunset
 * @replacementComponent Heading
 */
export function Heading2(props: Heading2Props) {
  useSunsetWarning({ componentName: 'Heading2', substitute: 'Heading' });

  return <Heading {...props} {...globalProps} variant="heading-3" />;
}

Heading2.defaultProps = {
  as: 'h3',
  align: 'inherit',
  trim: false,
  children: undefined,
};

Heading2.displayName = 'Heading2';

export default Heading2;
